import PlatformFeesPayable from "../general/PlatformFeesPayable"
import CommissionCalculator from "./CommissionCalculator"

export default function CommissionDetails() {
    return (
        <div className="user-profile-main-container">

            <div className="user-profile-container">
                <PlatformFeesPayable />

                {/* <CommissionCalculator /> */}
            </div>

        </div>
    )
}